// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Dl-z","slideIn":"El-z"};